export class GoogleCaptcha3 {

  static execute(siteKey, action, inputSelector) {

    return new Promise((resolve, reject) => {

      grecaptcha.ready(function() {
        window.grecaptcha.execute(siteKey, {action: action}).then(function (token) {
          if (token && inputSelector) {
            $(inputSelector).val(token);
          }
          resolve(token);
        });
      });

    });
  }
}
window.GoogleCaptcha3 = GoogleCaptcha3;